/**
 * Generated from ch6_p02.fla
 */
export function ch6_p02(this: Ich6_p02) {
	const rain = this.rain;
	if (!rain[0] && rain.elementFactory) {
		rain[0] = rain.elementFactory(0,undefined);
	}
	if (rain[0]) {
		ch6_p02_hh_ch6_72dpi_p02psdAssetrainoverlayrain2.call(rain[0] as Ich6_p02_hh_ch6_72dpi_p02psdAssetrainoverlayrain2);
		rain[0].x = 838.75;
		rain[0].y = 366.5;
		rain[0].width = 1650.50;
		rain[0].height = 683.00;
		rain[0].alpha = 1;
		if (rain[0].onLayout) rain[0].onLayout();
	}
	if (!rain[1] && rain.elementFactory) {
		rain[1] = rain.elementFactory(1,undefined);
	}
	if (rain[1]) {
		ch6_p02_hh_ch6_72dpi_p02psdAssetrainoverlayrain1.call(rain[1] as Ich6_p02_hh_ch6_72dpi_p02psdAssetrainoverlayrain1);
		rain[1].x = 806.75;
		rain[1].y = 414.5;
		rain[1].width = 1600.50;
		rain[1].height = 707.00;
		rain[1].alpha = 1;
		if (rain[1].onLayout) rain[1].onLayout();
	}
	const bg = this.bg;
	ch6_p02_hh_ch6_72dpi_p02psdAssetchp6_p02_bg.call(this.bg);
	bg.x = 832;
	bg.y = 384;
	bg.width = 1664.00;
	bg.height = 768.00;
	bg.alpha = 1.00;
	if (bg.onLayout) bg.onLayout();
	const horse = this.horse;
	ch6_p02_hh_ch6_72dpi_p02psdAssetchp6_p02_horse.call(this.horse);
	horse.x = 965;
	horse.y = 768;
	horse.width = 1209.00;
	horse.height = 738.00;
	horse.alpha = 1.00;
	if (horse.onLayout) horse.onLayout();
	const holly = this.holly;
	ch6_p02_hh_ch6_72dpi_p02psdAssetchp6_p02_holly.call(this.holly);
	holly.x = 848;
	holly.y = 768;
	holly.width = 286.00;
	holly.height = 593.00;
	holly.alpha = 1.00;
	if (holly.onLayout) holly.onLayout();
	const tyler = this.tyler;
	ch6_p02_hh_ch6_72dpi_p02psdAsset1chp6_p02_tyler.call(this.tyler);
	tyler.x = 1052;
	tyler.y = 768;
	tyler.width = 394.00;
	tyler.height = 762.00;
	tyler.alpha = 1.00;
	if (tyler.onLayout) tyler.onLayout();
	const tylerArm = this.tylerArm;
	ch6_p02_hh_ch6_72dpi_p02psdAsset1lower.call(this.tylerArm);
	tylerArm.x = 1249.5;
	tylerArm.y = 456;
	tylerArm.width = 263.50;
	tylerArm.height = 293.00;
	tylerArm.alpha = 1.00;
	if (tylerArm.onLayout) tylerArm.onLayout();
	const tylerPocketFront = this.tylerPocketFront;
	ch6_p02_hh_ch6_72dpi_p02psdAsset1pocket.call(this.tylerPocketFront);
	tylerPocketFront.x = 1090.5;
	tylerPocketFront.y = 633.75;
	tylerPocketFront.width = 263.00;
	tylerPocketFront.height = 268.50;
	tylerPocketFront.alpha = 1.00;
	if (tylerPocketFront.onLayout) tylerPocketFront.onLayout();
	const tylerRain = this.tylerRain;
	ch6_p02_hh_ch6_72dpi_p02psdAsset1drops.call(this.tylerRain);
	tylerRain.x = 1039.5;
	tylerRain.y = 365.75;
	tylerRain.width = 344.00;
	tylerRain.height = 681.50;
	tylerRain.alpha = 1.00;
	if (tylerRain.onLayout) tylerRain.onLayout();
	const gift = this.gift;
	ch6_p02_hh_ch6_72dpi_p02psdAssetchp6_p02_gift.call(this.gift);
	gift.x = 755.5;
	gift.y = 768;
	gift.width = 408.00;
	gift.height = 220.50;
	gift.alpha = 1.00;
	if (gift.onLayout) gift.onLayout();
	const frameRight = this.frameRight;
	ch6_p02_hh_ch6_72dpi_p02psdAssetchp6_p02_wcframeRframe.call(this.frameRight);
	frameRight.x = 1664;
	frameRight.y = 384;
	frameRight.width = 354.00;
	frameRight.height = 768.00;
	frameRight.alpha = 1.00;
	if (frameRight.onLayout) frameRight.onLayout();
	const linesRight = this.linesRight;
	ch6_p02_hh_ch6_72dpi_p02psdAssetchp6_p02_wcframerlines.call(this.linesRight);
	linesRight.x = 1664;
	linesRight.y = 412.75;
	linesRight.width = 101.50;
	linesRight.height = 644.50;
	linesRight.alpha = 1.00;
	if (linesRight.onLayout) linesRight.onLayout();
	const frameLeft = this.frameLeft;
	ch6_p02_hh_ch6_72dpi_p02psdAssetchp6_p02_wcframeLframe.call(this.frameLeft);
	frameLeft.x = 0;
	frameLeft.y = 384;
	frameLeft.width = 342.50;
	frameLeft.height = 768.00;
	frameLeft.alpha = 1.00;
	if (frameLeft.onLayout) frameLeft.onLayout();
	const linesLeft = this.linesLeft;
	ch6_p02_hh_ch6_72dpi_p02psdAssetchp6_p02_wcframellines.call(this.linesLeft);
	linesLeft.x = 0;
	linesLeft.y = 662.25;
	linesLeft.width = 77.50;
	linesLeft.height = 93.50;
	linesLeft.alpha = 1.00;
	if (linesLeft.onLayout) linesLeft.onLayout();
	return this;
}
function ch6_p02_hh_ch6_72dpi_p02psdAssetchp6_p02_bg(this: Ich6_p02_hh_ch6_72dpi_p02psdAssetchp6_p02_bg) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp6_p02_bg", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p02_hh_ch6_72dpi_p02psdAssetchp6_p02_horse(this: Ich6_p02_hh_ch6_72dpi_p02psdAssetchp6_p02_horse) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp6_p02_horse", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p02_hh_ch6_72dpi_p02psdAssetchp6_p02_holly(this: Ich6_p02_hh_ch6_72dpi_p02psdAssetchp6_p02_holly) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp6_p02_holly", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p02_hh_ch6_72dpi_p02psdAsset1chp6_p02_tyler(this: Ich6_p02_hh_ch6_72dpi_p02psdAsset1chp6_p02_tyler) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp6_p02_tyler", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p02_hh_ch6_72dpi_p02psdAsset1lower(this: Ich6_p02_hh_ch6_72dpi_p02psdAsset1lower) {
	if (this.setLayoutTexture) this.setLayoutTexture("lower", 1.000, 0.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p02_hh_ch6_72dpi_p02psdAsset1pocket(this: Ich6_p02_hh_ch6_72dpi_p02psdAsset1pocket) {
	if (this.setLayoutTexture) this.setLayoutTexture("pocket", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p02_hh_ch6_72dpi_p02psdAsset1drops(this: Ich6_p02_hh_ch6_72dpi_p02psdAsset1drops) {
	if (this.setLayoutTexture) this.setLayoutTexture("drops", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p02_hh_ch6_72dpi_p02psdAssetchp6_p02_gift(this: Ich6_p02_hh_ch6_72dpi_p02psdAssetchp6_p02_gift) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp6_p02_gift", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p02_hh_ch6_72dpi_p02psdAssetrainoverlayrain2(this: Ich6_p02_hh_ch6_72dpi_p02psdAssetrainoverlayrain2) {
	if (this.setLayoutTexture) this.setLayoutTexture("rain2", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("overlay");
	return this;
}
function ch6_p02_hh_ch6_72dpi_p02psdAssetrainoverlayrain1(this: Ich6_p02_hh_ch6_72dpi_p02psdAssetrainoverlayrain1) {
	if (this.setLayoutTexture) this.setLayoutTexture("rain1", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p02_hh_ch6_72dpi_p02psdAssetchp6_p02_wcframeRframe(this: Ich6_p02_hh_ch6_72dpi_p02psdAssetchp6_p02_wcframeRframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("Rframe", 1.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch6_p02_hh_ch6_72dpi_p02psdAssetchp6_p02_wcframerlines(this: Ich6_p02_hh_ch6_72dpi_p02psdAssetchp6_p02_wcframerlines) {
	if (this.setLayoutTexture) this.setLayoutTexture("rlines", 1.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p02_hh_ch6_72dpi_p02psdAssetchp6_p02_wcframeLframe(this: Ich6_p02_hh_ch6_72dpi_p02psdAssetchp6_p02_wcframeLframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("Lframe", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch6_p02_hh_ch6_72dpi_p02psdAssetchp6_p02_wcframellines(this: Ich6_p02_hh_ch6_72dpi_p02psdAssetchp6_p02_wcframellines) {
	if (this.setLayoutTexture) this.setLayoutTexture("llines", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
interface Ich6_p02Array<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface Ich6_p02Container {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface Ich6_p02Sprite extends Ich6_p02Container {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
	alpha: number;
	setBlendMode?(blendMode: string): void;
}
interface Ich6_p02Text extends Ich6_p02Container {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface Ich6_p02Polygon extends Array<number> {
}
interface Ich6_p02 {
	readonly rain: Ich6_p02Array<Ich6_p02_hh_ch6_72dpi_p02psdAssetrainoverlayrain2|Ich6_p02_hh_ch6_72dpi_p02psdAssetrainoverlayrain1>;
	readonly bg: Ich6_p02_hh_ch6_72dpi_p02psdAssetchp6_p02_bg;
	readonly horse: Ich6_p02_hh_ch6_72dpi_p02psdAssetchp6_p02_horse;
	readonly holly: Ich6_p02_hh_ch6_72dpi_p02psdAssetchp6_p02_holly;
	readonly tyler: Ich6_p02_hh_ch6_72dpi_p02psdAsset1chp6_p02_tyler;
	readonly tylerArm: Ich6_p02_hh_ch6_72dpi_p02psdAsset1lower;
	readonly tylerPocketFront: Ich6_p02_hh_ch6_72dpi_p02psdAsset1pocket;
	readonly tylerRain: Ich6_p02_hh_ch6_72dpi_p02psdAsset1drops;
	readonly gift: Ich6_p02_hh_ch6_72dpi_p02psdAssetchp6_p02_gift;
	readonly frameRight: Ich6_p02_hh_ch6_72dpi_p02psdAssetchp6_p02_wcframeRframe;
	readonly linesRight: Ich6_p02_hh_ch6_72dpi_p02psdAssetchp6_p02_wcframerlines;
	readonly frameLeft: Ich6_p02_hh_ch6_72dpi_p02psdAssetchp6_p02_wcframeLframe;
	readonly linesLeft: Ich6_p02_hh_ch6_72dpi_p02psdAssetchp6_p02_wcframellines;
}
interface Ich6_p02_hh_ch6_72dpi_p02psdAssetchp6_p02_bg extends Ich6_p02Sprite {
}
interface Ich6_p02_hh_ch6_72dpi_p02psdAssetchp6_p02_horse extends Ich6_p02Sprite {
}
interface Ich6_p02_hh_ch6_72dpi_p02psdAssetchp6_p02_holly extends Ich6_p02Sprite {
}
interface Ich6_p02_hh_ch6_72dpi_p02psdAsset1chp6_p02_tyler extends Ich6_p02Sprite {
}
interface Ich6_p02_hh_ch6_72dpi_p02psdAsset1lower extends Ich6_p02Sprite {
}
interface Ich6_p02_hh_ch6_72dpi_p02psdAsset1pocket extends Ich6_p02Sprite {
}
interface Ich6_p02_hh_ch6_72dpi_p02psdAsset1drops extends Ich6_p02Sprite {
}
interface Ich6_p02_hh_ch6_72dpi_p02psdAssetchp6_p02_gift extends Ich6_p02Sprite {
}
interface Ich6_p02_hh_ch6_72dpi_p02psdAssetrainoverlayrain2 extends Ich6_p02Sprite {
}
interface Ich6_p02_hh_ch6_72dpi_p02psdAssetrainoverlayrain1 extends Ich6_p02Sprite {
}
interface Ich6_p02_hh_ch6_72dpi_p02psdAssetchp6_p02_wcframeRframe extends Ich6_p02Sprite {
}
interface Ich6_p02_hh_ch6_72dpi_p02psdAssetchp6_p02_wcframerlines extends Ich6_p02Sprite {
}
interface Ich6_p02_hh_ch6_72dpi_p02psdAssetchp6_p02_wcframeLframe extends Ich6_p02Sprite {
}
interface Ich6_p02_hh_ch6_72dpi_p02psdAssetchp6_p02_wcframellines extends Ich6_p02Sprite {
}
